import printJS from "print-js";
import { findObjectUseCase } from "../../../usecases/object";
import * as XLSX from "xlsx";
export const printChart = (chartRefId) => {
  setTimeout(() => {
    printJS({
      printable: chartRefId,
      type: "html",
      header: `<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                   <img src="/figaro.png" alt="Figaro" style="height: 50px;"/>
                   <h4 style="margin: 0 auto;">FIGARO COFFEE GROUP</h4>
                   <img src="/angels.png" alt="Angel's Pizza" style="height: 50px;"/>
                 </div>`,
      css: "./index.css",
      scanStyles: false,
      style: ".print-only-content { display: block; }",
    });
  }, 500);
};

export function formatSales(sales) {
  return sales.toLocaleString("en-US", {
    style: "currency",
    currency: "PHP",
  });
}

function convertToCSV(arrOfObjects, title) {
  if (!arrOfObjects || arrOfObjects.length === 0) {
    return "";
  }

  // 1) Title row + blank line
  let csv = title + "\n\n";

  // 2) Headers (use the keys of the first object)
  const headers = Object.keys(arrOfObjects[0]);
  csv += headers.join(",") + "\n";

  // 3) Each row
  arrOfObjects.forEach((obj) => {
    const row = headers.map((key) => {
      // Escape any double‐quotes in the value, and wrap in quotes if needed
      let val = obj[key] != null ? String(obj[key]) : "";
      if (val.includes(",") || val.includes('"')) {
        val = `"${val.replace(/"/g, '""')}"`;
      }
      return val;
    });
    csv += row.join(",") + "\n";
  });

  return csv;
}

function sumSales(source) {
  if (!source) return 0;

  // If it's an array of items: [{ sales, quantity, ...}, ...]
  if (Array.isArray(source)) {
    return source.reduce((sum, it) => sum + (Number(it?.sales) || 0), 0);
  }

  // If it's an object map: { "00001": { sales, quantity }, ... }
  return Object.values(source).reduce(
    (sum, it) => sum + (Number(it?.sales) || 0),
    0
  );
}

function toNumber(v) {
  if (v == null) return 0;
  if (typeof v === "number" && Number.isFinite(v)) return v;
  // Strip commas, spaces, currency symbols, etc.
  const n = Number(String(v).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(n) ? n : 0;
}

export async function exportToCSV(
  datasetType,
  isTop = true,
  numberOfItems = 3000,
  storess,
  range,
  itemDataRevenue,
  itemDataQuantity,
  itemDataQuantityFree
) {
  if (!range || !range.tran_date) {
    console.error("exportToCSV: missing or invalid `range`");
    return;
  }

  // 1) Fetch the full master list
  const masterList = await findObjectUseCase().execute("angels_masterlist");

  const masterSkuSet = new Set(
    masterList.map((prod) => String(prod.sku).padStart(5, "0"))
  );

  console.log("itemDataRevenue,", itemDataRevenue);

  // 2) Normalize itemDataRevenue keys
  const normalizedRevenue = {};
  Object.keys(itemDataRevenue || {}).forEach((key) => {
    const normKey = String(key)
      .replace(/[^0-9]/g, "")
      .padStart(5, "0");
    normalizedRevenue[normKey] = itemDataRevenue[key];
  });

  console.log("normalize", normalizedRevenue);

  // 3) Check missing SKUs
  const missingSkus = Object.keys(normalizedRevenue)
    .filter((sku5) => !masterSkuSet.has(sku5))
    .map((sku5) => ({
      SKU: sku5,
      Sales: normalizedRevenue[sku5]?.sales || 0,
      Quantity: normalizedRevenue[sku5]?.quantity || 0,
      Description: normalizedRevenue[sku5]?.description || "(no description)",
    }));

  if (missingSkus.length > 0) {
    console.warn(
      `⚠️ Found ${missingSkus.length} SKU(s) in itemDataRevenue not in angels_masterlist:`
    );
    console.table(missingSkus);
    // 🧮 Compute totals
    const totalMissingSales = missingSkus.reduce(
      (sum, item) => sum + Number(item.Sales || 0),
      0
    );
    const totalMissingQty = missingSkus.reduce(
      (sum, item) => sum + Number(item.Quantity || 0),
      0
    );

    console.warn(
      `🧾 TOTAL (missing SKUs): Sales = ${totalMissingSales.toLocaleString()} | Quantity = ${totalMissingQty}`
    );

    // 🧾 Build CSV with clear columns
    const headers = ["SKU", "DESCRIPTION", "SALES", "QUANTITY"];
    const csvRows = [
      headers.join(","), // header row
      ...missingSkus.map((item) =>
        [
          item.SKU,
          `"${(item.Description || "").replace(/"/g, '""')}"`, // escape quotes safely
          item.Sales,
          item.Quantity,
        ].join(",")
      ),
      ["TOTAL", "", totalMissingSales, totalMissingQty].join(","),
    ];

    const csvContent = csvRows.join("\n");

    // 💾 Create blob and download CSV
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `missing-skus-${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  } else {
    console.log("✅ All SKUs in itemDataRevenue exist in masterlist.");
  }

  // 2) Build mergedRows array
  const mergedRows = masterList.map((prod) => {
    const rawSku = String(prod.sku);
    const sku5 = rawSku.padStart(5, "0");
    const description = prod.description || "";

    // Use 0 if missing
    const totalRevenueSales = sumSales(itemDataRevenue);
    // console.log("[TOTAL REVENUE - ALL ITEMS] sales:", totalRevenueSales);
    // console.log("sku5", sku5);
    // console.log("itemDataRevenue", itemDataRevenue);
    // console.log("itemDataRevenue[sku5]", itemDataRevenue[sku5]);
    // console.log("ITEM-REVENUE", itemDataRevenue);
    const revAgg = itemDataRevenue[sku5] || { sales: 0, quantity: 0 };
    const qtyAgg = itemDataQuantity[sku5] || { sales: 0, quantity: 0 };
    const revAggFree = itemDataQuantityFree[sku5] || { sales: 0, quantity: 0 };

    return {
      Store: storess,
      Date: `${range.tran_date["$gte"].split("T")[0]} - ${
        range.tran_date["$lte"].split("T")[0]
      }`,
      SKU: sku5,
      Item_Name: description,
      // For revenue‐based CSV rows, use revAgg; for quantity‐based, use qtyAgg
      // Revenue: Number(revAgg.sales),
      Revenue: toNumber(revAgg.sales),
      Sold_Quantity: revAgg.quantity,
      Free_Quanity: revAggFree.quantity,
      " ": " ",
      DineIn_Revenue: revAgg?.dineInRevenue,
      DineIn_Sold: revAgg?.dineInSold,
      TakeOut_Revenue: revAgg?.takeOutRevenue,
      TakeOut_Sold: revAgg?.takeOutSold,
      Delivery_Revenue: revAgg?.deliveryRevenue,
      Delivery_Sold: revAgg?.deliverySold,
      Grab_Revenue: revAgg?.grabRevenue,
      Grab_Sold: revAgg?.grabSold,
      DelTime_Revenue: revAgg?.delTimeRevenue,
      DelTime_Sold: revAgg?.deltimeSold,
      DriveThru_Revenue: revAgg?.driveThruRevenue,
      DriveThru_Sold: revAgg?.driveThruSold,
      FoodPanda_Revenue: revAgg?.foodPandaRevenue,
      FoodPanda_Sold: revAgg?.foodPandaSold,
      TableVibe_Revenue: revAgg?.tableVibeRevenue,
      TableVibe_Sold: revAgg?.tableVibeSold,

      // Stores: storess,
      // Dates: `${range.tran_date["$gte"].split("T")[0]} - ${
      //   range.tran_date["$lte"].split("T")[0]
      // }`,
      // SKUs: sku5,
      // Item_Names: description,
      // // For revenue‐based CSV rows, use revAgg; for quantity‐based, use qtyAgg
      // // Revenue: Number(revAgg.sales),
      // Revenues: toNumber(revAggFree.sales),
      // Quantitys: revAggFree.quantity,
    };
  });

  // 3) Decide which slice to take
  let title;
  let fileNameSuffix;
  let sortedRows;

  if (datasetType === "revenue") {
    title = isTop ? "Top Item Revenue" : "Bottom Item Revenue";
    fileNameSuffix = isTop ? "top-item-revenue" : "bottom-item-revenue";

    sortedRows = mergedRows
      .sort((a, b) => (isTop ? b.Revenue - a.Revenue : a.Revenue - b.Revenue))
      .slice(0, numberOfItems);
  } else if (datasetType === "quantity") {
    title = isTop ? "Top Item Quantity" : "Bottom Item Quantity";
    fileNameSuffix = isTop ? "top-item-quantity" : "bottom-item-quantity";

    sortedRows = mergedRows
      .sort((a, b) =>
        isTop ? b.Quantity - a.Quantity : a.Quantity - b.Quantity
      )
      .slice(0, numberOfItems);
  } else {
    console.error("exportToCSV: invalid datasetType:", datasetType);
    return;
  }

  // 4) Convert to CSV string
  const csvString = convertToCSV(sortedRows, title);
  if (!csvString) {
    console.error("exportToCSV: nothing to download (empty CSV).");
    return;
  }

  // 5) Trigger browser download
  const blob = new Blob([csvString], { type: "text/csv" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");

  const dateRange = `${range.tran_date["$gte"].split("T")[0]}-${
    range.tran_date["$lte"].split("T")[0]
  }`;
  a.href = url;
  a.download = `${storess}-${dateRange}-${fileNameSuffix}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
}

// export async function exportToCSV(
//   datasetType,
//   isTop = true,
//   numberOfItems = 3000,
//   storess,
//   range,
//   itemDataRevenue,
//   itemDataQuantity,
//   itemDataQuantityFree
// ) {
//   if (!range || !range.tran_date) {
//     console.error("exportToXLSX: missing or invalid `range`");
//     return;
//   }

//   // 1️⃣ Fetch masterlist
//   const masterList = await findObjectUseCase().execute("angels_masterlist");

//   // 2️⃣ Build mergedRows array (same logic as before)
//   const mergedRows = masterList.map((prod) => {
//     const rawSku = String(prod.sku);
//     const sku5 = rawSku.padStart(5, "0");
//     const description = prod.description || "";

//     const revAgg = itemDataRevenue[sku5] || { sales: 0, quantity: 0 };
//     const revAggFree = itemDataQuantityFree[sku5] || { sales: 0, quantity: 0 };

//     return {
//       Store: storess,
//       Date: `${range.tran_date["$gte"].split("T")[0]} - ${
//         range.tran_date["$lte"].split("T")[0]
//       }`,
//       SKU: sku5,
//       Item_Name: description,
//       Revenue: revAgg.sales,
//       Quantity: revAgg.quantity,
//       // blank separator
//       "": "",
//       Free_Revenue: revAggFree.sales,
//       Free_Quantity: revAggFree.quantity,
//     };
//   });

//   // 3️⃣ Convert JSON → Worksheet
//   const worksheet = XLSX.utils.json_to_sheet(mergedRows);

//   // 4️⃣ Apply header styling and column widths
//   const rangeRef = XLSX.utils.decode_range(worksheet["!ref"]);
//   for (let C = rangeRef.s.c; C <= rangeRef.e.c; ++C) {
//     const headerCell = worksheet[XLSX.utils.encode_cell({ r: 0, c: C })];
//     if (headerCell && headerCell.v) {
//       headerCell.s = {
//         fill: { fgColor: { rgb: "CCE5FF" } }, // light blue background
//         font: { bold: true },
//         alignment: { horizontal: "center", vertical: "center" },
//       };
//     }
//   }

//   worksheet["!cols"] = [
//     { wch: 10 }, // Store
//     { wch: 15 }, // Date
//     { wch: 10 }, // SKU
//     { wch: 30 }, // Item Name
//     { wch: 12 }, // Revenue
//     { wch: 12 }, // Quantity
//     { wch: 3 }, // separator column (blank space)
//     { wch: 15 }, // Free Revenue
//     { wch: 15 }, // Free Quantity
//   ];

//   // 5️⃣ Create workbook and save
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

//   const dateRange = `${range.tran_date["$gte"].split("T")[0]}-${
//     range.tran_date["$lte"].split("T")[0]
//   }`;
//   const fileName = `${storess}-${dateRange}-top-item-report.xlsx`;

//   XLSX.writeFile(workbook, fileName);
// }

export function getChartDataTopRevenue(itemDataRevenue) {
  // 1) Sort items by descending sales, then take top 30
  const sortedItems = Object.entries(itemDataRevenue)
    .sort((a, b) => b[1].sales - a[1].sales)
    .slice(0, 30);

  // 2) Extract labels (descriptions) and numeric sales data
  const labels = sortedItems.map(([, item]) => item.description);
  const salesData = sortedItems.map(([, item]) =>
    parseFloat(item.sales.toFixed(2))
  );

  // 3) Return the Highcharts configuration object
  return {
    chart: {
      type: "bar", // horizontal bar
    },
    title: {
      text: "Top 30 Menu Items by Revenue",
    },
    xAxis: {
      categories: labels,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "10px", // agar hindi masyadong malaki pag mahaba ang text
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total Sales (PHP)",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valuePrefix: "₱",
      valueDecimals: 2,
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "₱{point.y:.2f}",
        },
      },
    },
    series: [
      {
        name: "Total Sales",
        data: salesData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataBottomRevenue(itemDataRevenue) {
  const sortedItems = Object.entries(itemDataRevenue || {})
    .sort((a, b) => a[1].sales - b[1].sales)
    .slice(0, 30);

  const labels = sortedItems.map(([, item]) => item.description);
  const salesData = sortedItems.map(([, item]) =>
    parseFloat(item.sales.toFixed(2))
  );

  return {
    chart: { type: "bar" },
    title: { text: "Bottom 30 Items by Revenue" },
    xAxis: {
      categories: labels,
      title: { text: null },
      labels: { style: { fontSize: "10px" } },
    },
    yAxis: {
      min: 0,
      title: { text: "Total Sales (PHP)", align: "high" },
      labels: { overflow: "justify" },
    },
    tooltip: { valuePrefix: "₱", valueDecimals: 2 },
    plotOptions: {
      bar: {
        dataLabels: { enabled: true, format: "₱{point.y:.2f}" },
      },
    },
    series: [
      {
        name: "Total Sales",
        data: salesData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataTopQuantity(itemDataQuantity) {
  // 1) Sort items descending by quantity, take top 30
  const sortedItems = Object.entries(itemDataQuantity || {})
    .sort((a, b) => b[1].quantity - a[1].quantity)
    .slice(0, 30);

  // 2) Extract labels (descriptions) and numeric quantities
  const labels = sortedItems.map(([, item]) => item.description);
  const quantityData = sortedItems.map(([, item]) => parseFloat(item.quantity));

  // 3) Build and return Highcharts options
  return {
    chart: {
      type: "bar", // horizontal bar
    },
    title: {
      text: "Top 30 Items by Quantity",
    },
    xAxis: {
      categories: labels,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "10px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total Quantity",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valueSuffix: " pcs",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "{point.y} pcs",
        },
      },
    },
    series: [
      {
        name: "Total Quantity",
        data: quantityData,
        color: "#006096",
      },
    ],
  };
}

export function getChartDataBottomQuantity(itemDataQuantity) {
  // 1) Sort ascending by quantity, take bottom 30
  const sortedItems = Object.entries(itemDataQuantity || {})
    .sort((a, b) => a[1].quantity - b[1].quantity)
    .slice(0, 30);

  // 2) Extract labels and quantity values
  const labels = sortedItems.map(([, item]) => item.description);
  const quantityData = sortedItems.map(([, item]) => item.quantity);

  // 3) Build and return Highcharts options
  return {
    chart: {
      type: "bar",
    },
    title: {
      text: "Bottom 30 Items by Quantity",
    },
    xAxis: {
      categories: labels,
      title: {
        text: null,
      },
      labels: {
        style: {
          fontSize: "10px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: "Total Quantity",
        align: "high",
      },
      labels: {
        overflow: "justify",
      },
    },
    tooltip: {
      valueSuffix: " pcs",
    },
    plotOptions: {
      bar: {
        dataLabels: {
          enabled: true,
          format: "{point.y}",
        },
      },
    },
    series: [
      {
        name: "Quantity",
        data: quantityData,
        color: "#006096",
      },
    ],
  };
}
